import { render } from "./AuthUser.vue?vue&type=template&id=446a5396&scoped=true"
import script from "./AuthUser.vue?vue&type=script&lang=js"
export * from "./AuthUser.vue?vue&type=script&lang=js"

import "./AuthUser.vue?vue&type=style&index=0&id=446a5396&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\wwwda\\OneDrive\\Desktop\\проекты-и-учебные-файлы-front\\pizzares\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-446a5396"]])

export default __exports__